(() => {
  'use strict';

  const VERSION = '2026-08-17-product-rail-v34';
  if (window.__ddProductRailV34 === VERSION) return;
  window.__ddProductRailV34 = VERSION;

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stockState(node) {
    const label = normalize(node.textContent);
    if (
      node.classList.contains('is-sold-out') ||
      label.includes('tükendi') ||
      label.includes('stokta yok') ||
      label.includes('sold out') ||
      label.includes('out of stock')
    ) return 'sold-out';

    if (
      label.includes('son birkaç') ||
      label.includes('son birka') ||
      label.includes('az kaldı') ||
      label.includes('low stock') ||
      label.includes('only a few')
    ) return 'low-stock';

    return 'in-stock';
  }

  function normalizeStock(node) {
    if (!(node instanceof Element)) return;
    const state = stockState(node);
    node.dataset.ddStockState = state;
    const visible = state !== 'in-stock';
    node.hidden = !visible;
    node.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function scan(scope = document) {
    if (scope.matches?.('.ddpd-section .ddnn-card__stock')) normalizeStock(scope);
    scope.querySelectorAll?.('.ddpd-section .ddnn-card__stock').forEach(normalizeStock);
  }

  function boot() {
    scan(document);

    document.addEventListener('shopify:section:load', event => {
      scan(event.target || document);
      window.setTimeout(() => scan(event.target || document), 80);
    });

    new MutationObserver(mutations => {
      if (!mutations.some(m => m.addedNodes && m.addedNodes.length)) return;
      scan(document);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
